<div class="container-fluid" [style.display]="showOnlyAddModal ? 'none' : ''">
    <div class="row ">
        <!-- Header -->
        <div class="col-12 col-md-12 bgWhite padHeder mobView">
            <div class="col-6 col-md-6 pad0" style="display: inline-block;vertical-align: sub;">
                <span style="font-size: 20px; margin-right: 10px;" (click)="back()">
                    <i class="fa fa-chevron-left"></i>
                </span>
                <h4 style="display: inline-block;">Units</h4>
            </div>
            <div class="col-6 col-md-6 pad0" style="display: inline-block;">
                <span style="float: right;">
                    <span class="label addOrgBtnM brdrRadius3" style="vertical-align: text-top;" (click)="open(mymodal,0)">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px;vertical-align: text-bottom;margin-right: 8px;"></i><span>Add</span>
                    </span>
                </span>
            </div>
        </div>
       
        <div class="col-md-12 webView"  style="padding: 15px 30px 15px 30px">
            <div class="col-md-4" style="padding: 0px; display: inline-block;">
                <h3 class="lblHeader newHeader" style="display: inline-block;">
                    Units
                </h3>
                <span style="float: right;">
                    <span class="btn orangeButton" (click)="open(mymodal,0)" title="Add New Unit"
                          style=" position: relative;cursor: pointer; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                    </span>
                </span>  
            </div>  
            
            <div class="col-md-8 col-lg-8" style="padding: 0px; display: inline-block; text-align: right;">
                <span class="darkBlueButton brdrRadius3" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px !important;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
        </div>
       
        <!-- Units List -->
        <div *ngIf="units.length > 0" class="col-md-12 col-12 col-sm-12 leftPad">
        <div class="col-md-4 col-12 col-sm-12 pad0M">
            <div *ngFor="let u of units let i = index" style="margin-bottom: 10px;" class="col-md-12 col-12 col-sm-12 orngBadgeM">
                <div class="col-md-5 col-5 col-sm-5" style="font-size: 13px;display: inline-block;padding: 0px;">
                <span style="font-size: 13px;">{{u.UNm}}</span>    
                </div>
                <div class="col-md-4 col-4 col-sm-4" style="color: #777 !important;font-size: 13px;display: inline-block;padding: 0px;text-align: right;">
                    <span *ngIf="u.Prcsn == 0">N</span>
                    <span *ngIf="u.Prcsn > 0">N.{{u.PrcCount}}</span>
                </div>
                <div class="col-md-3 col-3 col-sm-3" style="text-align: right;display: inline-block;padding: 0px;">
                    <div class="lableBtnOrange" style="margin-right: 5px; font-size: 13px; cursor: pointer; display: inline-block;" title="Edit {{u.UNm}}" (click)="open(mymodal,u.UID)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                    </div>

                    <div class="lableBtnOrange" *ngIf="u.isDefault" style="margin-left: 5px; font-size: 13px; cursor: pointer; display: inline-block;" title="Delete {{u.UNm}}" 
                        (click)="fn_deleteUnits(u.UID, i)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
        
        </div>
        <div class="bgWhite" style="padding-top: 15px;padding-left: 30px;" *ngIf="units.length == 0">
            <div class="nrf brdrRadius3" (click)="open(mymodal,0)">
                Click here to add a unit.
            </div>
        </div> 
     </div>
</div> 

<!--Add unit-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header bgModal" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title newHeader"><span id="ApntmntHdr">{{isEdit == false ? 'Add Unit' : 'Edit Unit'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body bgModal" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div *ngIf="isEdit == false" class="col-md-6 col-xs-8 col-8 font13" style="padding: 0px 15px 10px 0px;display: inline-block;">
                <label class="label-new" style="margin-bottom: 0; padding: 0; font-size: 13px;">Unit</label>
                <input type="text" [(ngModel)]="unit" class="form-control formCtlFltr brdrRadius3" maxlength="50" style="text-indent: 2px;font-size: 13px; background-color: white !important;">
            </div>
            <div *ngIf="isEdit == true" class="col-md-4 col-xs-5 col-5 font13" style="padding: 0px 15px 10px 3px;display: inline-block;">
                <span>{{unit}}</span>
            </div>
            <div *ngIf="isEdit == false" class="col-md-3 col-xs-4 col-4 preWidth font13" style="padding: 0px;display: inline-block;">
                <label class="label-new" style="margin-bottom: 0; padding: 0; font-size: 13px;">Precision</label>
                <input type="text" numbersOnly [(ngModel)]="prcsn" class="form-control formCtlFltr brdrRadius3" maxlength="1"  style="text-indent: 2px; text-align: right;font-size: 13px; background-color: white !important;">
            </div> 
            <div *ngIf="isEdit == true" class="col-md-3 col-xs-3 col-3 preWidth font13" style="padding: 0px;display: inline-block;">
                <label class="label-new" style="margin-bottom: 0; padding: 0; font-size: 13px;">Precision</label>
                <input type="text" numbersOnly [(ngModel)]="prcsn" class="form-control formCtlFltr brdrRadius3" maxlength="1"  style="text-indent: 2px; text-align: right;font-size: 13px; background-color: white !important;">
            </div>  
            <div class="col-md-9 col-xs-12 col-12 font13" style="display: inline-block;color: #DAA520;padding: 5px 0px 0px 5px;">
                <span>E.g. 3 precision = 0.123</span>
            </div>  
        </div>
        
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px; font-size: 13px;">
            <div style="display: flex; column-gap: 10px;">
                <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px;" (click)="isEdit == false ? saveNewUnit(unit,prcsn) : editUnitSave(unit,prcsn)" >
                    <i class="fa fa-check" style="margin-right: 5px;"></i>
                    <span>Save</span>
                </span>
                <span class="btn-darkBlue brdrRadius3 mobView" style="padding: 0px 10px;" (click)="closeModal()" >
                    <i class="fa fa-close" style="margin-right: 5px; padding-top: 1px; vertical-align: middle;"></i>
                    <span style="vertical-align: text-top;">Close</span>
                </span>
            </div>       
        </div>
        
    </div>
</ng-template>
